
import { Component, Mixins } from "vue-property-decorator";
import { default as StyledDrawableObjectMixin } from "./StyledDrawableObjectMixin.vue";
import { default as CheckDrawableMixin } from "./CheckDrawableMixin.vue";

@Component({
})
export default class StyledCheckDrawableObjectMixin extends Mixins(
  StyledDrawableObjectMixin,
  CheckDrawableMixin
) {
}
